export default function PopularHolidays() {
  return (
    <>

 <section id="our_populardealss">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Today's Top<strong> Cheap Hotels</strong> Deals</h2>
          <p>Choose from the best Hotels</p>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="100">
              <img src={"assets/img/holidays/holidays (1).avif"} alt="travelclss  1" className="img-fluid" />
              <div className="details">
                <h3><a href="#">Flash<span> Sale</span></a></h3>
                <p>Cheap Flight Tickets Sale</p>
                <div className="social">
                 <p>Fares Starting from $99* Only</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="200">
              <img src={"../assets/img/holidays/holidays (2).avif"} alt="travelclss  2" className="img-fluid" />
              <div className="details">
                <h3><a href="#">Flat<span> Tickets</span></a></h3>
                <p>Cheap Flight Tickets Sale</p>
                <div className="social">
                <p>Fares Starting from $99* Only</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="300">
              <img src={"../assets/img/holidays/holidays (3).avif"} alt="travelclss  3" className="img-fluid" />
              <div className="details">
                  <h3><a href="#">Visit <span> Africa</span></a></h3>
                <p>Special Fares to Various Sectors</p>
                <div className="social">
                <p>Fares Starting from $2000* Only</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="100">
              <img src={"../assets/img/holidays/holidays (4).avif"} alt="travelclss  4" className="img-fluid" />
              <div className="details">
                <h3><a href="#">All India<span> Sale</span></a></h3>
                <p>Enjoy Special fares to Destinations</p>
                <div className="social">
                <p>Special Fares to Various Sectors</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="200">
              <img src={"../assets/img/holidays/holidays (5).avif"} alt="travelclss  5" className="img-fluid" />
              <div className="details">
                <h3><a href="#">Korean Air<span> Offer</span></a></h3>
                <p>Enjoy Special fares to Destinations</p>
                <div className="social">
                <p>Special Fares to Various Sectors</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className="travelclss" data-aos="fade-up" data-aos-delay="300">
              <img src={"../assets/img/holidays/holidays (6).avif"} alt="travelclss  6" className="img-fluid" />
              <div className="details">
                <h3><a href="#">Oman Air<span> Sale</span></a></h3>
                <p>Enjoy Special fares to Destinations</p>
                <div className="social">
                <p>Special Fares to Various Sectors</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
    </>
  );
}
